import axios from 'axios'

// ============================================================================
// CONSTANTS
// ============================================================================
const API_VERSION = '/v2'
const LOGIN_ROUTE = '/login'
const HTTP_STATUS = {
  UNAUTHORIZED: 401
}

const STORAGE_KEYS = {
  USER: 'user',
  EMAIL: 'email',
  LANGUAGE: 'language',
  AVATAR: 'avatar',
  PRODUCER: 'producer',
  TOKEN: 'token',
  EXPIRES_IN: 'expiresIn',
  FARM_ID: 'farmId',
  FARM_TZ: 'farmTz'
}

const DEFAULT_HEADERS = {
  Accept: 'application/json'
}

// ============================================================================
// API INSTANCE CONFIGURATION
// ============================================================================
const atarrayaApi = axios.create({
  baseURL: process.env.VUE_APP_ATARRAYA_API_URL + API_VERSION,
  timeout: process.env.VUE_APP_ATARRAYA_TIMEOUT
})

// ============================================================================
// HELPER FUNCTIONS
// ============================================================================
const getAuthToken = () => {
  return localStorage.getItem(STORAGE_KEYS.TOKEN)
}

const clearUserSession = () => {
  Object.values(STORAGE_KEYS).forEach(key => {
    localStorage.removeItem(key)
  })
}

const redirectToLogin = () => {
  window.location = LOGIN_ROUTE
}

// ============================================================================
// REQUEST INTERCEPTOR
// ============================================================================
atarrayaApi.interceptors.request.use(
  async (config) => {
    const token = getAuthToken()
    
    if (token) {
      config.headers = {
        ...DEFAULT_HEADERS,
        Authorization: `Bearer ${token}`
      }
    } else {
      config.headers = DEFAULT_HEADERS
    }
    
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// ============================================================================
// RESPONSE INTERCEPTOR
// ============================================================================
atarrayaApi.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    if (error.response?.status === HTTP_STATUS.UNAUTHORIZED) {
      clearUserSession()
      redirectToLogin()
    }
    
    return Promise.reject(error)
  }
)

// ============================================================================
// EXPORTS
// ============================================================================
export { 
  atarrayaApi,
  STORAGE_KEYS,
  HTTP_STATUS
}